export default  {"src":"/_next/static/image/public/assets/nevo-boi/chevron-right.27872ff990f309acbac83de83e0066f6.svg","height":22,"width":22};